export default __webpack_public_path__ + "static/eskimo-49a844bfe03cf6a6d522714167fb3835.png";